// export const authConstants = {
//   LOGIN_REQUEST: "LOGIN_REQUEST",
//   LOGIN_FAILURE: "LOGIN_FAILURE",
//   LOGIN_SUCCESS: "LOGIN_SUCCESS",
//   LOGOUT_REQUEST: "LOGOUT_REQUEST",
//   SIGNUP_REQUEST: "SIGNUP_REQUEST",
//   SIGNUP_FAILURE: "SIGNUP_FAILURE",
//   SIGNUP_SUCCESS: "SIGNUP_SUCCESS",
// };

export const API = 'https://ash-biomedical-backend.herokuapp.com/api/v1/';
// export const API = "http://localhost:4000/api/v1/";

export const token = sessionStorage.getItem("token");
